import { Navbar, NavbarBrand } from 'reactstrap';

const NavBar = () => (
  <Navbar
    color="dark"
    dark
  >
    <NavbarBrand>
      Lula Api Console
    </NavbarBrand>
  </Navbar>
);

export default NavBar;
